@for (tio of this.ios(); track $index) {
    <div>{{tio.ioType.toString()}}:{{this.rangedKanaalLabel(tio)}}</div>
}   
